<template>
    <div class="modal fade" id="book_demo" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="book_demo_form">
                        <h2>Book A Demo</h2>
                        <div v-if="success_status" class="alert alert-success alert-dismissible fade show" role="alert">
                            <strong>Your request has been submitted to the admin</strong>
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form  v-on:submit.prevent="book_a_demo">
                            <input type="text" v-model="name"  name="name" placeholder="Name*" v-bind:class="{required : isInputValid(errors.name)}">
                            <input type="email" v-model="email"  name="email" placeholder="Email*" v-bind:class="{required : isInputValid(errors.email)}">
                            <input type="text" v-model="contact_number"  name="contact_number" placeholder="Contact Number*" v-bind:class="{required : isInputValid(errors.contact_number)}">
                            <input type="text" v-model="workplace"  name="workplace" placeholder="Work place*" v-bind:class="{required : isInputValid(errors.workplace)}">
                            <select v-model="program"  name="program" v-bind:class="{required : isInputValid(errors.program)}">
                                <option> Select Program</option>
                                <option value="Incident and event management ">Incident and event management </option>
                                <option value="Audit management">Audit management</option>
                                <option value="Workforce compliance">Workforce compliance</option>
                                <option value="Action and improvement plans">Action and improvement plans</option>
                                <option value="Document management">Document management</option>
                                <option value="Risk management">Risk management</option>
                                <option value="Business compliance">Business compliance</option>
                                <option value="Analytics">Analytics</option>
                                <option value="Hospital information system (HIS)">Hospital information system (HIS)</option>
                                <option value="Laboratory information system (LIS)">Laboratory information system (LIS)</option>    
                            </select>
                            <input type="submit" name="submit" value="Book A Demo" v-if="!processing">
                            <input type="submit" name="submit" value="Wait..." v-if="processing">
                        </form>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'BookDemo',
    data(){
        return {
            errors:[],
            name:null,
            email:null,
            contact_number:null,
            workplace:null,
            program:null,
            processing:false,
            success_status:false
        }
    },

    methods:{
        isInputValid(input){
            return (typeof input != "undefined" && input!="");
        },
        getError(input){
            return (typeof input != "undefined" && input!="") ? input[0] : '';
        },
        book_a_demo() {
            var _self = this; 
            _self.errors = [];
            _self.success_status = false;
            this.processing = true;
            this.$axios_global.post(_self.$hostname+'/api/book-demo',
            {
                name:_self.name,
                email:_self.email,
                contact_number:_self.contact_number,
                workplace:_self.workplace,
                program:_self.program
            })
            .then((res) => {
                _self.processing = false;
                _self.success_status = true;
                _self.name=null;
                _self.email=null;
                _self.contact_number=null;
                _self.workplace=null;
                _self.program=null;
            })
            .catch((error) => {
                _self.processing = false;
                _self.errors = error.response.data;
                return false;  
            })   
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/BookDemo.vue